import { ReactNode } from "react";

interface EmailFieldProps {
  name: string;
  defaultValue?: string;
  placeholder?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

const EmailField: React.FunctionComponent<EmailFieldProps> = ({
  name,
  defaultValue,
  icon,
  disabled,
  placeholder
}) => {
  
  return (
    <div className="relative">
      {icon && (
        <div className={"input-icon" + (disabled ? " disabled" : "")}>
          {icon}
        </div>
      )}

      <input
        type="email"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        className="input-field"
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default EmailField;